module.exports = __webpack_public_path__ + "media/honey-icons/icon-home-type-semi-detached-684a4a7a.svg";